module.exports = __webpack_public_path__ + "static/img/img-metodologia-1.e37ed9af.jpg";